import type { TSCTheme } from "@/ui/theme/commonTheme";

/**
 * The theme charts draw with, without loading chart.js (NEXT.md A2): the app's theme provider
 * sets it at boot, and `chartjs.ts` applies it when the first chart loads and on every change.
 */
let current: TSCTheme | null = null;
const listeners = new Set<(theme: TSCTheme) => void>();

export const setChartTheme = (theme: TSCTheme) => {
  current = theme;
  listeners.forEach((listener) => listener(theme));
};

/** Calls `listener` with the current theme now (if one is set) and on every change. */
export const onChartTheme = (listener: (theme: TSCTheme) => void) => {
  listeners.add(listener);
  if (current !== null) listener(current);
  return () => {
    listeners.delete(listener);
  };
};
